export type Language = 'ko' | 'en'

export interface SubscrptionPlan {
  text: string
  link: string
  price: number
  isAnnual: boolean
  planCode: PlanCode
}

export enum PlanCode {
  FREE = 'ODK-FREE',
  PLUS_MONTHLY = 'ODK-PLUS-1-MONTH',
  PLUS_ANNUAL = 'ODK-PLUS-1-YEAR',
  PREMIUM_MONTHLY = 'ODK-PREMIUM-1-MONTH',
  PREMIUM_ANNUAL = 'ODK-PREMIUM-1-YEAR',
}

export enum PlanLevel {
  FREE = 'free',
  PLUS = 'plus',
  PREMIUM = 'premium',
}

export interface PaymentPlanCode {
  code: PlanCode
  price: number
  level: PlanLevel
}

export enum AuthRegistrationType {
  INHOUSE,
  OAUTH2,
}
